// Rueckmeldung beim Abschicken: ohne sie passiert nach dem Klick
// sekundenlang sichtbar nichts und Leute klicken ein zweites Mal.
// Betrifft die Formulare, nach denen die Seite neu laedt: Warenkorb,
// Kasse und "In den Warenkorb".

const merker = (form) => {
    if (form.dataset.fnBusy) {
        return;
    }

    form.dataset.fnBusy = '1';

    form.addEventListener('submit', (ereignis) => {
        // Der Warenkorb hat zwei Schaltflaechen (Aktualisieren und Zur
        // Kasse) - gemeint ist die, die tatsaechlich geklickt wurde.
        const aktiv = document.activeElement;
        const knopf = ereignis.submitter
            || (aktiv && form.contains(aktiv) && /^(INPUT|BUTTON)$/.test(aktiv.tagName) ? aktiv : null)
            || form.querySelector('input[type="submit"], button[type="submit"]');

        if (!knopf) {
            return;
        }

        // Erst nach dem Absenden umschalten, damit Name und Wert des
        // Knopfes noch mitgehen.
        window.setTimeout(() => {
            knopf.classList.add('fn-laeuft');

            if (knopf.tagName === 'INPUT') {
                knopf.value = 'Einen Moment …';
            } else {
                knopf.textContent = 'Einen Moment …';
            }
        }, 0);
    });
};

document.querySelectorAll('form').forEach((form) => {
    if (form.querySelector('input[name="add_to_cart"], input[name="button_checkout"], input[name="nextStep"]')) {
        merker(form);
    }
});


// Contao gibt Formularfelder ohne autocomplete aus - auf dem Handy bietet
// der Browser dann weder Name noch E-Mail an, obwohl er beides kennt. Nur
// Felder mit eindeutigem Namen; Rechenschutz und Honigtopf bleiben aussen
// vor. (Stand vorher als Regex-Ersetzung in form_wrapper.html5.)
const formFelder = {
    name: 'name',
    vorname: 'given-name',
    nachname: 'family-name',
    email: 'email',
    'e-mail': 'email',
    telefon: 'tel',
    phone: 'tel',
    tel: 'tel',
    firma: 'organization',
    strasse: 'address-line1',
    plz: 'postal-code',
    ort: 'address-level2'
};

document.querySelectorAll('.ce_form input[name]').forEach((feld) => {
    const wert = formFelder[feld.name.toLowerCase()];

    if (wert && !feld.hasAttribute('autocomplete')) {
        feld.setAttribute('autocomplete', wert);
    }
});
